module.exports = __webpack_public_path__ + "static/media/dinner.af082abc.jpg";